<div class="cm-stepper" role="list" [attr.aria-label]="ariaLabel()">
  @for (step of steps(); track step; let i = $index; let last = $last) {
    <div
      class="cm-stepper__step"
      role="listitem"
      [attr.aria-current]="i === activeIndex() ? 'step' : null"
    >
      <div class="cm-stepper__row">
        <div
          class="cm-stepper__dot"
          [class.cm-stepper__dot--completed]="i < activeIndex()"
          [class.cm-stepper__dot--active]="i === activeIndex()"
        >
          @if (i < activeIndex()) {
            <cm-icon name="check" size="xs" aria-hidden="true" />
          }
        </div>
        @if (!last) {
          <div
            class="cm-stepper__connector"
            [class.cm-stepper__connector--completed]="i < activeIndex()"
          ></div>
        }
      </div>
      <span
        class="cm-stepper__label"
        [class.cm-stepper__label--active]="i === activeIndex()"
        [class.cm-stepper__label--completed]="i < activeIndex()"
      >
        <span class="cm-stepper__sr-status">
          @if (i < activeIndex()) {
            Completed:
          } @else if (i === activeIndex()) {
            Current step:
          }
        </span>
        {{ step }}
      </span>
    </div>
  }
</div>
